<div class="household-picker" [class.household-picker--disabled]="disabled">

  <!-- Collapsed trigger -->
  <button
    type="button"
    class="household-picker__trigger"
    [attr.aria-expanded]="expanded"
    [disabled]="disabled"
    (click)="toggle()">
    <ng-container *ngIf="!selectedHousehold; else pillTpl">
      Upload for household <span class="household-picker__optional">(optional)</span>
    </ng-container>
    <ng-template #pillTpl>
      <span class="household-picker__pill">
        {{ selectedHousehold!.name }}
        <button
          type="button"
          class="household-picker__clear"
          [disabled]="disabled"
          (click)="clearSelection(); $event.stopPropagation()"
          aria-label="Clear selection">&times;</button>
      </span>
    </ng-template>
  </button>

  <!-- Expanded dropdown panel -->
  <div class="household-picker__panel" *ngIf="expanded">

    <p class="household-picker__intent">
      If you select a household, all the files you upload will go to that household.
    </p>

    <button
      type="button"
      class="household-picker__create"
      (click)="openCreate()">
      Create new household
    </button>

    <div *ngIf="loading" class="household-picker__loading">Loading…</div>

    <ng-container *ngIf="!loading">
      <div *ngIf="items.length === 0" class="household-picker__empty">
        No households available.
      </div>

      <ul class="household-picker__list" *ngIf="items.length > 0">
        <li
          *ngFor="let item of items"
          class="household-picker__item"
          [class.household-picker__item--selected]="selectedHousehold?.id === item.id">
          <label class="household-picker__label">
            <input
              type="radio"
              [name]="'household-picker'"
              [value]="item.id"
              [checked]="selectedHousehold?.id === item.id"
              (change)="selectHousehold(item)" />
            {{ item.name }}
          </label>
        </li>
      </ul>

      <app-pagination
        *ngIf="total > 0"
        [mode]="'simple'"
        [page]="page"
        [pageSize]="pageSize"
        [total]="total"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </ng-container>

  </div>

  <!-- Create Household modal -->
  <app-new-household
    *ngIf="createOpen"
    [isOpen]="createOpen"
    (close)="createOpen = false"
    (householdCreated)="onHouseholdCreated($event)">
  </app-new-household>

</div>
